import Alpine from "alpinejs";

Alpine.data("iframe", () => ({
    uuid: null,
    iframeInstances: {},

    init() {
        let self = this;

        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-iframeSettings') {
                self.changeSettings(event.data.data);
            }
        });
    },

    start(data, uuid) {

        if (uuid) {
            this.uuid = uuid;
            // Initialize the buttonsInstances if not already present
            if (!this.iframeInstances[uuid]) {
                this.iframeInstances[uuid] = {
                    iframeSrc: data.iframeSrc,
                    width: data.width,
                    height: data.height,
                    aspectRation: data.aspectRation
                };
            }
        }

        this.updateIframeStyle(uuid);
    },

    changeSettings(data) {
        let json = JSON.parse(data);

        this.iframeInstances[json.id] = {
            iframeSrc: json.iframeSrc,
            width: json.width,
            height: json.height,
            aspectRation: json.aspectRation
        };

        this.updateIframeStyle(json.id);
    },

    updateIframeStyle(uuid) {
        // If width and height are provided directly, use them
        if (this.iframeInstances[uuid].width && this.iframeInstances[uuid].height) {
            this.iframeInstances[uuid].iframeStyle = `width: ${this.iframeInstances[uuid].width}%; height: ${this.iframeInstances[uuid].height}px;`;
        }
        // If aspect ratio is provided, compute height based on width
        else if (this.iframeInstances[uuid].aspectRatio && this.iframeInstances[uuid].width) {
            const [wRatio, hRatio] = this.iframeInstances[uuid].aspectRatio.split('/').map(Number);
            const computedHeight = (this.iframeInstances[uuid].width / wRatio) * hRatio;
            this.iframeInstances[uuid].iframeStyle = `width: ${this.iframeInstances[uuid].width}%; height: ${computedHeight}px;`;
        }
        // Default fallback
        else {
            this.iframeInstances[uuid].iframeStyle = '';
        }
    }
}));
